module.exports = __webpack_public_path__ + "img/ats-y1.683fe095.gif";